<ion-header [translucent]="true">
  <ion-toolbar color="primary">
    <ion-buttons slot="start"><ion-menu-button></ion-menu-button></ion-buttons>
    <ion-title>Saját wifi eszközeim</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content>
  <ion-card>
    <ion-card-header>
      <ion-card-title>Eszköz bejelentése az iskolai wifire</ion-card-title>
      <ion-card-subtitle *ngIf="bejelenthet">
        A bejelentett eszköz a <b>{{ sajatVlan }}-es VLAN-ra</b> kerül. Az adminisztrátor
        elbírálja; addig az eszköz még nem tud csatlakozni.
      </ion-card-subtitle>
    </ion-card-header>
    <ion-card-content>

      <!-- Gondviselő: nem jelenthet be. Ezt kimondjuk, nem csak elrejtjük az űrlapot. -->
      <div class="tilt-doboz" *ngIf="!bejelenthet && !toltodik">
        Gondviselői belépéssel nem lehet eszközt bejelenteni az iskolai wifire –
        a hálózat a diákok és a dolgozók eszközeit fogadja.
      </div>

      <div *ngIf="bejelenthet">
        <div class="urlap">
          <ion-input fill="outline" label="MAC-cím" labelPlacement="stacked"
                     placeholder="A1:B2:C3:D4:E5:F6" [(ngModel)]="uj.mac"></ion-input>
          <ion-input fill="outline" label="Eszköz neve" labelPlacement="stacked"
                     placeholder="pl. Saját laptop" [(ngModel)]="uj.device_name"></ion-input>
          <ion-input fill="outline" label="Megjegyzés (nem kötelező)" labelPlacement="stacked"
                     [(ngModel)]="uj.megjegyzes"></ion-input>
          <ion-button size="small" color="success" (click)="bekuld()" [disabled]="kuldes">
            <ion-icon slot="start" name="send-outline"></ion-icon>Bejelentés
          </ion-button>
        </div>
        <div class="sugo">
          A MAC-cím az eszköz hálózati azonosítója. Androidon: Beállítások → Wifi → a hálózat
          részletei; iPhone-on: Beállítások → Általános → Névjegy → Wi-Fi-cím; Windowsban:
          <code>ipconfig /all</code> → Fizikai cím. Kötőjellel, kettősponttal vagy anélkül is beírhatod.
        </div>
      </div>
    </ion-card-content>
  </ion-card>

  <ion-card>
    <ion-card-header>
      <ion-card-title>Bejelentett eszközeim</ion-card-title>
    </ion-card-header>
    <ion-card-content>
      <ion-spinner name="crescent" *ngIf="toltodik"></ion-spinner>
      <div class="eszkoz-lista">
        <div class="eszkoz" *ngFor="let e of eszkozok">
          <div style="flex:1">
            <div class="nev">{{ e.device_name || 'Névtelen eszköz' }}</div>
            <div class="mac">{{ e.mac_formazott }}</div>
            <div class="meta" *ngIf="e.vlan_id">VLAN {{ e.vlan_id }}</div>
            <div class="indok" *ngIf="e.statusz === 'elutasitva' && e.elbiralas_indok">
              Indoklás: {{ e.elbiralas_indok }}
            </div>
          </div>
          <div style="text-align:right">
            <ion-badge [color]="allapotSzin(e.statusz)">{{ allapotNev(e.statusz) }}</ion-badge>
            <div *ngIf="e.statusz === 'jovahagyva' && !e.enabled" class="meta">jelenleg letiltva</div>
            <div style="margin-top:6px" *ngIf="e.statusz === 'kerelem'">
              <ion-button size="small" fill="clear" color="medium" (click)="visszavon(e)">
                Visszavonás
              </ion-button>
            </div>
          </div>
        </div>
      </div>
      <ion-note color="medium" *ngIf="!eszkozok.length && !toltodik">
        Még nincs bejelentett eszközöd.
      </ion-note>
    </ion-card-content>
  </ion-card>
</ion-content>
